/*
 * Add-to-cart toast.
 *
 * Shown instead of opening the cart drawer when the "After adding to cart"
 * theme setting is set to Toast. Driven by a `cart-toast:show` event that
 * cart-drawer.js dispatches from the add-to-cart response, so it only fires
 * once the item is actually in the cart.
 *
 * Deliberately dependency-free so it can load anywhere in the theme.
 */
(function () {
  var VISIBLE_DURATION = 4000;
  var hideTimer;

  function onShow(event) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;

    var title = event && event.detail && event.detail.title;
    if (!title) return;

    var template = toast.dataset.message || '[product] was added to your cart';

    // textContent, not innerHTML: product titles are merchant data and may
    // contain characters that would otherwise be parsed as markup.
    var text = toast.querySelector('.cart-toast__text');
    if (!text) return;
    text.textContent = template.replace('[product]', title);

    toast.hidden = false;
    // Force a reflow so the transition still runs when a previous toast is
    // on screen and only the text is being swapped.
    void toast.offsetWidth;
    toast.classList.add('cart-toast--visible');

    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      toast.classList.remove('cart-toast--visible');
    }, VISIBLE_DURATION);
  }

  function onDismiss(event) {
    var button = event.target.closest && event.target.closest('.cart-toast__close');
    if (!button) return;
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    clearTimeout(hideTimer);
    toast.classList.remove('cart-toast--visible');
  }

  document.addEventListener('cart-toast:show', onShow);
  document.addEventListener('click', onDismiss);
})();
